module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/san-francisco-15dc559bb13187f21236a3824c84ba24.webp";